var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 79.36 79.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .d {\n        fill: #9aa7a9;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M39.68,0h0c21.92,0,39.68,17.77,39.68,39.68h0c0,21.92-17.77,39.68-39.68,39.68h0C17.77,79.36,0,61.6,0,39.68h0C0,17.77,17.77,0,39.68,0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.2,
    cy: 26.96,
    r: 5.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.16,
    cy: 26.96,
    r: 5.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNone);
export default __webpack_public_path__ + "static/media/none.fb51b302b49fd1bb5716604b5f1f023a.svg";
export { ForwardRef as ReactComponent };